import { apiRequest } from "./util";

function submit(data) {
  return apiRequest("waitlist", "POST", data);
}

export default { submit };
